import produce from 'immer';

import {
  CLEAR_SUBMISSION_SETTINGS,
  FETCH_SUBMISSION_SETTINGS_FAILURE,
  FETCH_SUBMISSION_SETTINGS_SUCCESS,
  UPDATE_SUBMISSION_SETTINGS_FAILURE,
  UPDATE_SUBMISSION_SETTINGS_SUCCESS,
} from '@actions/submissionSettings';

const initialState: ISubmissionSettingsStore = {
  submissionSettings: null,
  error: null,
};

export default (state: ISubmissionSettingsStore = initialState, action: any) =>
  produce(state, (draftState: ISubmissionSettingsStore) => {
    switch (action.type) {
      case FETCH_SUBMISSION_SETTINGS_SUCCESS:
      case UPDATE_SUBMISSION_SETTINGS_SUCCESS:
        draftState.submissionSettings = action.response;
        draftState.error = null;

        return;

      case FETCH_SUBMISSION_SETTINGS_FAILURE:
      case UPDATE_SUBMISSION_SETTINGS_FAILURE:
        draftState.error = action.error;

        return;

      case CLEAR_SUBMISSION_SETTINGS:
        draftState.submissionSettings = null;

        return;
    }
  });
